<template>
  <header class="site-header">
    <a href="#" class="brand-main">
      <img
        id="logo-desk"
        src="/assets/img/lacolima.png"
        class="d-none d-md-inline"
        style="height: 30px;"
      >
      <img
        id="logo-mobile"
        src="/assets/img/lacolima.png"
        alt="Laraspace Logo"
        style="height: 25px;"
        class="d-md-none"
      >
    </a>
    <a href="#" class="nav-toggle" @click="onNavToggle">
      <div class="hamburger hamburger--arrowturn">
        <div class="hamburger-box">
          <div class="hamburger-inner" />
        </div>
      </div>
    </a>
    <ul class="action-list">

      <i class="breadcrumb-item"/>{{nombre}}
      <li>
        <v-dropdown :show-arrow="false">
          <a href="#" class="notification" slot="activator" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            <i class="icon-fa icon-fa-bell"/>
            <span class="badge">{{getNumberNotifications(notifications)}}</span>
          </a>
          <div class="notification-dropdown">
            <h6 class="dropdown-header">Notificaciones</h6>
            <v-dropdown-item v-for="notification in notifications" :key="notification.id">
              <a class="dropdown-item" @click="viewNotification(notification.id)">
                <i v-bind:class="'icon-fa '+notification.icon" />{{notification.message}}
              </a>
            </v-dropdown-item>
            <v-dropdown-item>
              <router-link
                  class="dropdown-item"
                  :to="`/admin/notifications`">
                <i class="icon-fa icon-fa-eye"/>Ver historial de notificaciones
              </router-link>
            </v-dropdown-item>
          </div>
        </v-dropdown>
      </li>
      <li>
        <v-dropdown :show-arrow="false">
          <a slot="activator" href="#" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false" class="avatar">
            <img src="/assets/img/avatars/avatar.png" alt="Avatar" />
          </a>
          <v-dropdown-item>
            <a href="#" class="dropdown-item" @click.prevent="logout">
              <i class="icon-fa icon-fa-sign-out" /> Cerrar sesión
            </a>
          </v-dropdown-item>
        </v-dropdown>
      </li>
    </ul>
  </header>
</template>
<script type="text/babel">
  import Auth from "../../../services/auth";
  import Roles from "../../../services/roles";
  import gql from 'graphql-tag';
  import Ls from '../../../services/ls'
  export default {
    apollo: {
      notifications: {
        query: gql`
          query notifications($iduser: Int!,$status: Boolean!){
            notifications(iduser: $iduser,status: $status){
              id
              message
              status
              icon
            }
          }
        `
        ,variables(){
          return{
            iduser: this.user.id,
            status: false,
          }
        }
        , pollInterval: 300,
      }
    },
    data(){
      return{
        user:{
          id:0,
          idrole:'',
          namePlace:'',
          placeId:'',
          user:''
        },
        nombre: ''
      }
    },
    methods: {
      onNavToggle() {
        this.$utils.toggleSidebar();
      },
      logout() {
        Roles.logout()
        Auth.logout().then(() => {
          this.$router.replace("/");
        });
      },
      getUser() {
        let me = this;
        axios.get('/api/sale/getUser')
          .then((response) => {
            me.user = response.data;
          }).catch((error) => {
            console.log(error);
          })
      },
      getCurrentUser() {
        var cortar = Ls.get('auth.name')
        this.nombre = cortar.slice(1,-1)
      },
      getNumberNotifications(notifications) {
        if (typeof (notifications) === "undefined")
          return '';
        else if(notifications.length===0)
          return '';
        else
          return notifications.length;
      },
      async viewNotification(id) {
        const resultado = await this.$apollo.mutate({
          mutation:
            gql`mutation ($id: ID!,$status: Boolean!){
                notificationView(id: $id,status: $status){
                    id
                }
              }`,
          variables:{
            id: id,
            status: true
          }
        }).catch((error)=>{
          console.log(error);
        })
      },
    },
    mounted(){
      this.getUser();
      this.getCurrentUser();
    }
  }
</script>
<style>
  .notification {
    background-color: #000;
    color: white;
    text-decoration: none;
    padding: 15px 26px;
    position: relative;
    display: inline-block;
    border-radius: 2px;
  }

  .notification:hover {
    background: red;
  }

  .notification .badge {
    position: absolute;
    top: -10px;
    right: -10px;
    padding: 5px 10px;
    border-radius: 50%;
    background: red;
    color: white;
  }
</style>



// WEBPACK FOOTER //
// resources/js/views/layouts/partials/TheSiteHeader.vue